// Central data source for all 9 TCA Retainer packages
// All 8 step templates read from this file via URL params

export const PACKAGE_STEPS = [
  { key: 'intro',          path: '',               label: 'Introduction' },
  { key: 'details',        path: 'details',         label: 'Personal Details' },
  { key: 'poa',            path: 'poa',             label: 'SARS Power of Attorney' },
  { key: 'popi',           path: 'popi',            label: 'POPI Consent Agreement' },
  { key: 'pricing',        path: 'pricing',         label: 'Pricing' },
  { key: 'add-ons',        path: 'add-ons',         label: 'Add-Ons' },
  { key: 'engagement',     path: 'engagement',      label: 'Engagement Letter' },
  { key: 'payment',        path: 'payment',         label: 'Payment Method' },
  { key: 'debit-order',    path: 'debit-order',     label: 'Debit Order Mandate' },
];

export const PACKAGES = {
  'starter-bronze': {
    slug: 'starter-bronze',
    tier: 'Starter',
    level: 'Bronze',
    fullName: 'Starter Bronze',
    colorKey: 'bronze',
    tierDescription: 'For Compiled Financial Statements (Non-VAT companies)',
  },
  'starter-silver': {
    slug: 'starter-silver',
    tier: 'Starter',
    level: 'Silver',
    fullName: 'Starter Silver',
    colorKey: 'silver',
    tierDescription: 'For Compiled Financial Statements (Non-VAT companies)',
  },
  'starter-gold': {
    slug: 'starter-gold',
    tier: 'Starter',
    level: 'Gold',
    fullName: 'Starter Gold',
    colorKey: 'gold',
    tierDescription: 'For Compiled Financial Statements (Non-VAT companies)',
  },
  'core-bronze': {
    slug: 'core-bronze',
    tier: 'Core',
    level: 'Bronze',
    fullName: 'Core Bronze',
    colorKey: 'bronze',
    tierDescription: 'For Reviewed Financial Statements (VAT-registered companies)',
  },
  'core-silver': {
    slug: 'core-silver',
    tier: 'Core',
    level: 'Silver',
    fullName: 'Core Silver',
    colorKey: 'silver',
    tierDescription: 'For Reviewed Financial Statements (VAT-registered companies)',
  },
  'core-gold': {
    slug: 'core-gold',
    tier: 'Core',
    level: 'Gold',
    fullName: 'Core Gold',
    colorKey: 'gold',
    tierDescription: 'For Reviewed Financial Statements (VAT-registered companies)',
  },
  'elite-bronze': {
    slug: 'elite-bronze',
    tier: 'Elite',
    level: 'Bronze',
    fullName: 'Elite Bronze',
    colorKey: 'bronze',
    tierDescription: 'For Audited Financial Statements',
  },
  'elite-silver': {
    slug: 'elite-silver',
    tier: 'Elite',
    level: 'Silver',
    fullName: 'Elite Silver',
    colorKey: 'silver',
    tierDescription: 'For Audited Financial Statements',
  },
  'elite-gold': {
    slug: 'elite-gold',
    tier: 'Elite',
    level: 'Gold',
    fullName: 'Elite Gold',
    colorKey: 'gold',
    tierDescription: 'For Audited Financial Statements',
  },
};

export const VALID_SLUGS = Object.keys(PACKAGES);

export const getPackage = (slug) => PACKAGES[slug] || null;

export const getStepByKey = (key) => PACKAGE_STEPS.find(s => s.key === key) || null;

export const getStepIndex = (key) => PACKAGE_STEPS.findIndex(s => s.key === key);

export const getNextStep = (currentKey) => {
  const idx = getStepIndex(currentKey);
  return idx >= 0 && idx < PACKAGE_STEPS.length - 1 ? PACKAGE_STEPS[idx + 1] : null;
};

export const getPrevStep = (currentKey) => {
  const idx = getStepIndex(currentKey);
  return idx > 0 ? PACKAGE_STEPS[idx - 1] : null;
};

// Returns the full URL path for a given package + step
export const getStepPath = (packageSlug, stepKey) => {
  const step = getStepByKey(stepKey);
  if (!step) return `/${packageSlug}`;
  return step.path === '' ? `/${packageSlug}` : `/${packageSlug}/${step.path}`;
};

// Color styles for Bronze / Silver / Gold badges
export const getLevelStyles = (colorKey) => {
  if (colorKey === 'silver') {
    return {
      background: 'linear-gradient(to bottom, #C0C0C0, #E8E8E8, #A8A8A8)',
      color: '#333',
      border: '1px solid #B0B0B0',
    };
  }
  if (colorKey === 'gold') {
    return { background: '#B8860B', color: 'white', border: 'none' };
  }
  // bronze (default)
  return { background: '#8B5E3C', color: 'white', border: 'none' };
};
